module.exports = __webpack_public_path__ + "c8de3ee3f1f84a114101d1f84941f479.jpg";